<section class="p-3">
  <h2 class="title mb-4">Datos de abonado</h2>
  @if (isLoading()) {
  } @else {
    <p-card>
      <div class="subscriber-grid">
        <section class="subscriber-col">
          <h3 class="subscriber-title">Datos del contrato</h3>
          <dl class="info-list mb-0">
            <div class="info-row">
              <i class="pi pi-user info-icon" aria-hidden="true"></i>
              <div>
                <dt>Titular</dt>
                <dd>{{ tenantInfo()?.tenantName || '—' }}</dd>
              </div>
            </div>
            <div class="info-row">
              <i class="pi pi-envelope info-icon" aria-hidden="true"></i>
              <div>
                <dt>Email de contacto</dt>
                <dd>{{ tenantInfo()?.tenantEmail || '—' }}</dd>
              </div>
            </div>
            <div class="info-row">
              <i class="pi pi-phone info-icon" aria-hidden="true"></i>
              <div>
                <dt>Nº Teléfono</dt>
                <dd>{{ tenantInfo()?.tenantMobilePhone || '—' }}</dd>
              </div>
            </div>
          </dl>
        </section>

        <section class="subscriber-col">
          <h3 class="subscriber-title">Dirección de suministro</h3>
          <dl class="info-list mb-0">
            <div class="info-row">
              <i class="pi pi-map-marker info-icon" aria-hidden="true"></i>
              <div>
                <dt>Calle / Plaza</dt>
                <dd>{{ tenantInfo()?.tenantStreet || '—' }}</dd>
              </div>
            </div>
          </dl>
          <div class="info-split">
            <dl class="info-list mb-0">
              <div class="info-row">
                <i class="pi pi-hashtag info-icon" aria-hidden="true"></i>
                <div>
                  <dt>C. Postal</dt>
                  <dd>{{ tenantInfo()?.tenantPostalCode || '—' }}</dd>
                </div>
              </div>
            </dl>
            <dl class="info-list mb-0">
              <div class="info-row">
                <i class="pi pi-building info-icon" aria-hidden="true"></i>
                <div>
                  <dt>Localidad</dt>
                  <dd>{{ tenantInfo()?.tenantCity || '—' }}</dd>
                </div>
              </div>
            </dl>
          </div>
        </section>
      </div>

      @if (sendRequestsEnabled()) {
        <p class="info-hint">
          Si necesitas modificar estos datos, envíanos una consulta a través del formulario
          <a [routerLink]="['/', 'enviar-consulta']">Enviar consulta</a>, indicando los cambios que
          deseas realizar.
        </p>
      }
    </p-card>

    @if (canUseReciboVerde()) {
      <div class="recibo-wrap">
        <p-card styleClass="bg-primary-subtle-custom">
          <ng-template #title>
            <span class="d-inline-flex align-items-center gap-2">
              <img
                src="assets/img/logo_recibo_verde_sv_solo.svg"
                alt=""
                width="20"
                height="18"
                class="recibo-verde-card-title-icon"
              />
              ReciboVerde
            </span>
          </ng-template>
          <div class="d-flex align-items-center gap-4 p-3">
            <img
              src="assets/img/logo_recibo_verde_sv_solo.svg"
              style="width: 5rem"
              alt="ReciboVerde"
            />

            <div class="flex-grow-1">
              <div class="d-flex align-items-center gap-2">
                @if (sendSettlementByEmail()) {
                  <i class="pi pi-check-circle text-success fw-bold"></i>
                  <span id="act" class="text-success fw-bold">Activo</span>
                } @else {
                  <i class="pi pi-info-circle text-muted"></i>
                  <span class="text-muted fw-bold">No activo</span>
                }
              </div>

              <p class="m-0 mt-1 text-muted small">
                {{
                  sendSettlementByEmail()
                    ? 'Ya recibes tus liquidaciones por email.'
                    : 'Recibe tus liquidaciones por email.'
                }}
              </p>

              @if (!sendSettlementByEmail()) {
                <p-button
                  label="Activar ahora"
                  [text]="true"
                  styleClass="p-0 mt-2 fw-bold"
                  (onClick)="navigateToNotifications()"
                >
                </p-button>
              }
            </div>
          </div>
        </p-card>
      </div>
    }

    @if (isGGM()) {
      <h2 class="title my-4">Comunicaciones</h2>
      <p-card>
        <p class="comms-intro">
          Añade un móvil y activa el envío para recibir avisos por SMS o WhatsApp.
        </p>

        <div class="comms-layout">
          <section class="comms-panel">
            <h3 class="comms-subtitle">Números de teléfono</h3>
            <div class="phone-add">
              <p-floatlabel variant="in" class="flex-grow-1">
                <p-iconfield>
                  <p-inputicon class="pi pi-phone"></p-inputicon>
                  <input
                    pInputText
                    id="phone"
                    [formControl]="phoneCtrl"
                    class="w-100"
                    (keyup.enter)="addPhone()"
                  />
                </p-iconfield>
                <label for="phone">Número de teléfono</label>
              </p-floatlabel>
              <p-button
                icon="pi pi-plus"
                (onClick)="addPhone()"
                severity="primary"
                styleClass="h-100"
                ariaLabel="Añadir teléfono"
              ></p-button>
            </div>

            @if ($settings.phoneList().length === 0) {
              <p class="comms-empty">
                Todavía no hay teléfonos. Añade uno para poder activar el envío.
              </p>
            } @else {
              <ul class="comms-phones">
                @for (phone of $settings.phoneList(); track $index) {
                  <li>
                    <span class="comms-phone">
                      <i class="pi pi-mobile" aria-hidden="true"></i>
                      +34 {{ phone.phone }}
                    </span>
                    <p-button
                      icon="pi pi-minus-circle"
                      size="small"
                      [text]="true"
                      severity="danger"
                      [ariaLabel]="'Quitar teléfono +34 ' + phone.phone"
                      (onClick)="removePhone($index)"
                    ></p-button>
                  </li>
                }
              </ul>
            }
          </section>

          <section
            class="comms-panel"
            [class.comms-panel-muted]="$settings.phoneList().length === 0"
          >
            <h3 class="comms-subtitle">Envío</h3>
            <div class="comms-pref">
              <p-checkbox
                [binary]="true"
                [formControl]="waControl"
                inputId="wa-comms"
                (onChange)="onWhatsappToggle($event.checked)"
              >
              </p-checkbox>
              <div class="flex-grow-1">
                <label class="comms-pref-title" for="wa-comms">Comunicaciones telemáticas</label>
                <p class="comms-pref-desc">
                  SMS y WhatsApp de Gomez Group Metering a los números de la lista.
                </p>
                @if ($settings.phoneList().length === 0) {
                  <p class="comms-pref-warn">Añade un teléfono para activar esta opción.</p>
                }
              </div>
              <i class="pi pi-whatsapp comms-wa" aria-hidden="true"></i>
            </div>
          </section>
        </div>

        <div class="comms-footer">
          @if (!canSave()) {
            @if ($settings.phoneList().length === 0) {
              <p class="comms-save-hint">Añade un teléfono para guardar los cambios.</p>
            } @else {
              <p class="comms-save-hint">Activa las comunicaciones telemáticas para guardar.</p>
            }
          }
          <p-button label="Guardar cambios" [disabled]="!canSave()" (onClick)="saveChanges()">
          </p-button>
        </div>
      </p-card>
    }
  }
</section>

<p-dialog
  header="Protección de Datos"
  [(visible)]="showPrivacyModal"
  [modal]="true"
  [breakpoints]="{ '960px': '75vw', '576px': '95vw' }"
  [style]="{ width: '50vw' }"
  [closable]="false"
>
  <div class="privacy-content" style="max-height: 400px; overflow-y: auto">
    <h6 class="font-bold border-left-3 border-green-500 pl-2">
      Información básica sobre el tratamiento del número de teléfono móvil
    </h6>
    <p class="d-flex flex-column text-justify text-sm text-secondary my-3">
      <strong class="title">Responsable del tratamiento:</strong> Gomez Group Metering SLU<br />
      <strong class="title mt-3">Finalidad:</strong> Gestionar la relación contractual e informar
      vía SMS o WhatsApp Business.<br />
      <strong class="title mt-3">Legitimación:</strong> Ejecución del contrato.<br />
      <strong class="title mt-3">Destinatarios:</strong
      ><span
        >Sólo se cederán a las empresas del Grupo para ejecución del contrato y exclusivamente a
        terceras partes por obligación legal. El uso de WhatsApp implica una comunicación a través
        de dicha plataforma conforme a sus propias políticas de privacidad que se pueden consultar
        en la
        <a href="https://www.whatsapp.com/legal/business-app-privacy-policy?lang=es" target="_blank"
          >política de privacidad de WhatsApp</a
        >.</span
      ><br />
      <strong class="title mt-3">Derechos:</strong>
      <span
        >El cliente puede ejercer los derechos de acceso, rectificación, supresión, oposición,
        limitación del tratamiento y portabilidad, así como solicitar información adicional sobre el
        tratamiento de sus datos a través de dpo@gomezgroupmetering.com o en la C/ Llodio, 3 CP
        28034 Madrid.</span
      >
      <strong class="title d-flex flex-row mt-3">Información adicional:</strong>
      <span
        >Puede consultar la información ampliada sobre protección de datos en:
        <a href="www.gomezgroupmetering.com" target="_blank">www.gomezgroupmetering.com</a>.</span
      ><br />
    </p>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Cancelar"
      [text]="true"
      severity="secondary"
      (onClick)="cancelPrivacy()"
    ></p-button>
    <p-button label="Aceptar" severity="success" (onClick)="acceptPrivacy()"></p-button>
  </ng-template>
</p-dialog>
